export default __webpack_public_path__ + "static/diana_bw-fe422fc11a93e1dd3c213bda94bd23f6.jpeg";